/**
 * 申込番号
 */
export default class OrderNumber {
  /**
   * コンストラクタ
   */
  constructor(num, rev) {
    this.num = (typeof num === 'string') ? num.trim() : null;
    this.rev = (typeof rev === 'string') ? rev.trim() : null;
  }

  /**
   * ファクトリーメソッド - 申込番号と版数から作成
   */
  static of(num, rev) {
    return new OrderNumber(num, rev);
  }

  /**
   * ファクトリーメソッド - パスパラメーターから作成
   */
  static from(params) {
    const { order, rev } = params;
    return new OrderNumber(order, rev);
  }

  /** 申込番号 */
  value() {
    return this.num;
  }

  /** 有効性判定 */
  valid() {
    return !!this.num && !!this.rev;
  }

  /** リクエストパス作成 */
  path() {
    return (this.num && this.rev)
      ? this.num + '/' + this.rev
      : '';
  }

  /** 同一判定 */
  same(other) {
    return this.num === other?.num
        && this.rev === other?.rev;
  }

  /** 文字列化 */
  toString() {
    return [this.num, this.rev]
        .filter(Boolean)
        .join('-');
  }
}
